export default {
  'sysNotice.button.detail': 'Details',
  'sysNotice.query.title': 'Title',
  'sysNotice.query.title.placeholder': 'Enter title',
  'sysNotice.query.type': 'Notice Type',
  'sysNotice.query.type.placeholder': 'Select notice type',
  'sysNotice.query.status': 'Notice Status',
  'sysNotice.query.status.placeholder': 'Select notice status',
  'sysNotice.query.status.normal': 'Normal',
  'sysNotice.query.status.disabled': 'Disabled',
  'sysNotice.column.title': 'Title',
  'sysNotice.column.type': 'Notice Type',
  'sysNotice.column.description': 'Notice Description',
  'sysNotice.column.status': 'Notice Status',
  'sysNotice.column.status.normal': 'Normal',
  'sysNotice.column.status.disabled': 'Disabled',
  'sysNotice.column.createTime': 'Creation Time',
  'sysNotice.column.updateTime': 'Update Time',
  // edit
  'sysNotice.edit.title': 'Edit Notification',
  'sysNotice.edit.success': 'Successfully Modified',
  'sysNotice.add.title': 'Add Notification',
  'sysNotice.add.success': 'Successfully Added',
  'sysNotice.edit.form.title': 'Title',
  'sysNotice.edit.form.title.placeholder': 'Enter title',
  'sysNotice.edit.form.title.required': 'Enter title',
  'sysNotice.edit.form.description': 'Notice Description',
  'sysNotice.edit.form.description.placeholder': 'Enter notice description',
  'sysNotice.edit.form.description.required': 'Enter notice description',
  'sysNotice.edit.form.type': 'Notice Type',
  'sysNotice.edit.form.type.placeholder': 'Select notice type',
  'sysNotice.edit.form.type.required': 'Select notice type',
  'sysNotice.edit.form.status': 'Notice Status',
  'sysNotice.edit.form.status.placeholder': 'Select notice status',
  'sysNotice.edit.form.status.required': 'Select notice status',
  'sysNotice.edit.form.status.normal': 'Normal',
  'sysNotice.edit.form.status.disabled': 'Disabled',
  'sysNotice.edit.form.content': 'Notice Content',
  'sysNotice.edit.form.content.placeholder': 'Enter notice content',
  'sysNotice.edit.form.content.required': 'Enter notice content',
  // view dialog
  'sysNotice.viewDialog.title': 'Notification',
  'sysNotice.viewDialog.publisher': 'Publisher',
  'sysNotice.viewDialog.createTime': 'Publishing Time',
  'sysNotice.viewDialog.noPublisher': 'Unknown',
}
